import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useEffect } from "react";
import { useDispatch, connect } from "react-redux";
import Button from "../../../../../../components/Button";
import Grid from "../../../../../../components/Grid";
import Loader from "../../../../../../components/Loader";
import {
  FlexContainer,
  PageTitle,
} from "../../../../../../components/StyledComponents";
import { DateEStoDateEN } from "../../../../../../helpers/format-date";
import { getAcademyStats } from "../../../../../../store/actions/analytics";
import AnalyticCard from "../../../components/AnalyticCard";
import { PDFExport } from "@progress/kendo-react-pdf";
import {
  formatNumber,
  overThousandFixed,
} from "../../../../../../helpers/number-fixed";
import { AcademyAnalyticsDto } from "../../../../../../types/analytics.dto";
import { StateDto } from "../../../../../../types/states.dto";
import { CurrentDto } from "../../../../../../types/current.dto";

const Component = ({
  analyticsAcademy,
  analyticsAcademyStates,
  current,
}: {
  analyticsAcademy: AcademyAnalyticsDto;
  analyticsAcademyStates: StateDto;
  current: CurrentDto;
}) => {
  const printRef: any = React.useRef();
  const dispatch = useDispatch();
  const handleExportWithComponent = () => {
    printRef.current.save();
  };
  useEffect(() => {
    dispatch(getAcademyStats({ _id: current.id }));
  }, []);
  if (!analyticsAcademy) return <Loader color="Primary"></Loader>;

  return (
    <>
      <PageTitle>Dashboard</PageTitle>
      <Grid.Col offset={{ sm: 10 }} sm={12}>
        <Button
          onClick={() => {
            handleExportWithComponent();
          }}
          type="button"
          options={{
            type: "filled",
            skin: "primary",
            size: "md",
            marginBottom: "10px",
          }}
          style={{ marginLeft: "10px" }}
        >
          Descargar
        </Button>
      </Grid.Col>
      <PDFExport
        fileName={`Campus General ${new Date().valueOf()}`}
        ref={printRef}
      >
        <FlexContainer direction="column" gap="6px">
          {/* 
        setFilterProducts((prev) =>
          [...prev].sort((a, b) => (new Date(b.createdAt)) - (new Date(a.createdAt)))
        );
        
        */}
          <AnalyticCard
            graphTitle={"Vistas-Crecimiento Historico"}
            title={"Vistas"}
            data={{
              stats: [
                {
                  label: "Últimos 30 días",
                  value: overThousandFixed(
                    analyticsAcademy.academy.views.lastMonth
                  ),
                },
                {
                  label: "Últimos 7 días",
                  value: overThousandFixed(
                    analyticsAcademy.academy.views.lastWeek
                  ),
                },
                {
                  label: "Últimas 24 horas",
                  value: overThousandFixed(
                    analyticsAcademy.academy.views.lastDay
                  ),
                },
              ],
              graphData: Object.entries(analyticsAcademy.academy.views.growth)
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>
          <AnalyticCard
            graphTitle={"Usuarios-Crecimiento Historico"}
            title={"Usuarios"}
            data={{
              stats: [
                {
                  label: "Últimos 30 días",
                  value: overThousandFixed(
                    analyticsAcademy.academy.users.lastMonth
                  ),
                },
                {
                  label: "Últimos 7 días",
                  value: overThousandFixed(
                    analyticsAcademy.academy.users.lastWeek
                  ),
                },
                {
                  label: "Últimas 24 horas",
                  value: overThousandFixed(
                    analyticsAcademy.academy.users.lastDay
                  ),
                },
              ],
              graphData: Object.entries(analyticsAcademy.academy.users.growth)
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>
          <AnalyticCard
            graphTitle={"Interacciones-Crecimiento Historico"}
            title={"Indicadores Relevantes"}
            data={{
              stats: [
                {
                  value: overThousandFixed(
                    analyticsAcademy.academy.views.total
                  ),
                  label: "Vistas Totales",
                },
                {
                  value: overThousandFixed(
                    analyticsAcademy.academy.users.total
                  ),
                  label: "Usuarios Totales",
                },
                {
                  value: overThousandFixed(
                    analyticsAcademy.academy.clicks.total
                  ),
                  label: "Interacciones",
                },
              ],
              graphData: Object.entries(analyticsAcademy.academy.clicks.growth)
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>
          <AnalyticCard
            graphTitle={"Certificados-Crecimiento Historico"}
            title={"Indicadores Educativos"}
            data={{
              stats: [
                { value: analyticsAcademy.cohorts.current, label: "Cohorts" },
                { value: analyticsAcademy.units.total, label: "Modulos" },
                { value: analyticsAcademy.contents.total, label: "Contenidos" },
              ],
              graphData: Object.entries(analyticsAcademy.certificates.growth)
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>
          <AnalyticCard
            graphTitle={"Staff - Cantidad Total"}
            title={"Staff"}
            data={{
              stats: [
                {
                  value:
                    analyticsAcademy.academy.users.staff.currentAdmins +
                    analyticsAcademy.academy.users.staff.currentPms +
                    analyticsAcademy.academy.users.staff.currentProfessors,
                  label: "Total",
                },
                {
                  value: analyticsAcademy.academy.users.staff.currentAdmins,
                  label: "Admins",
                },
                {
                  value: analyticsAcademy.academy.users.staff.currentPms,
                  label: "PMs",
                },
                {
                  value: analyticsAcademy.academy.users.staff.currentProfessors,
                  label: "Mentores",
                },
              ],
              graphData: Object.entries(
                analyticsAcademy.academy.users.staff.history
              )
                .sort((a, b) => DateEStoDateEN(a[0]) - DateEStoDateEN(b[0]))
                .map((growthData) => {
                  return {
                    name: growthData[0],
                    value: formatNumber(growthData[1]),
                  };
                }),
            }}
          ></AnalyticCard>
        </FlexContainer>
      </PDFExport>
    </>
  );
};

const states = ({ analyticsStore, currentStore }) => {
  const { data: analyticsAcademy, states: analyticsAcademyStates } =
    analyticsStore.getAcademyStats;
  const { data: current } = currentStore;
  return {
    analyticsAcademy,
    analyticsAcademyStates,
    current,
  };
};

export default connect(states)(Component);
